import { render } from "./PaymentCard.vue?vue&type=template&id=04d0a511&scoped=true"
import script from "./PaymentCard.vue?vue&type=script&lang=js"
export * from "./PaymentCard.vue?vue&type=script&lang=js"

import "./PaymentCard.vue?vue&type=style&index=0&id=04d0a511&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d0a511"]])

export default __exports__